import React, { Component }from "react";
import Row from "reactstrap/lib/Row";
import  { Col } from "reactstrap/lib";
import { Button } from 'reactstrap';
import ApiEndpoints from "../../../constants/api_endpoints";
import store from "../../../store";
import { setError, setLoader } from "../../../actions/action-creators";
import moment from "moment";
import Table from "reactstrap/lib/Table";
import { Switch, TablePagination } from "@material-ui/core";
import InputFeild from "../../global/form/input";


class UserPayouts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            payoutData : [],
            userMetaData: {},
            currentPage: 0,
            isEditPayoutStatus: false
        }
    }

    componentDidMount(){
        this.showPayoutData();
        this.fetchUserMetaData();
    }

    fetchUserMetaData = async () => {
        store.dispatch(setLoader(true))
        try{
            var body = { user_id : this.props.user_id }
            let resp = await ApiEndpoints.User.fetchUserMetaData(body)
            this.setState({ userMetaData : resp.data.data[0] || {} })
        }
        catch(e){
            store.dispatch(setError({show: true, message: e.response ? e.response.data.message : e.toString()}))
        }
        store.dispatch(setLoader(false))
    }
  
    showPayoutData = async (user_id, job_id) => {
        store.dispatch(setLoader(true))
        try{
            var body = {
               user_id: this.props.user_id
            };
            let payoutDataResp = await ApiEndpoints.JobTaskPayment.fetchUserPayouts(body);
            let payoutData = payoutDataResp.data.data.sort((a, b) => new Date(b.created_on) - new Date(a.created_on));
         await this.setState({ payoutData })

        }
        catch(e){
            store.dispatch(setError({show: true, message: e.response ? e.response.data.message : e.toString()}))
        }
        store.dispatch(setLoader(false))
    } 
    
    updatePayoutStatus = async () => {
        store.dispatch(setLoader(true));
        let { userMetaData, isEditPayoutStatus } = this.state;
        try{
            var body = {
               user_id: this.props.user_id,
               payout_status: userMetaData.payout_status,
               payout_remark: isEditPayoutStatus.remark || ""
            };
            await ApiEndpoints.User.updateUserMetaData(body);
            this.setState({ isEditPayoutStatus: false })
        }
        catch(e){
            store.dispatch(setError({show: true, message: e.response ? e.response.data.message : e.toString()}))
        }
        store.dispatch(setLoader(false))
    }

      
    
    render() {
        let { payoutData, userMetaData, isEditPayoutStatus } = this.state;
        return (
            <div className="px-1 text-center" style={{fontSize: 14}}>     
                    {!!userMetaData.payout_status && 
                        <Row className="my-3 bg-light py-2 border rounded shadow-sm">
                            <Col><span className="font-weight-bold">Payout Status</span></Col>

                            <Col>
                                <Switch style={{color: userMetaData.payout_status === 2 ? "#dc3545" : "#198754"}} size="small" color="default" checked={userMetaData.payout_status !== 2} onClick={(e) => { userMetaData.payout_status = e.target.checked ? 1 : 2; this.setState({ isEditPayoutStatus: {}, userMetaData }) }} />
                                {userMetaData.payout_status === 2 ? 
                                    <span className="font-weight-bold text-danger">HOLD</span>
                                    :
                                    <span className="font-weight-bold text-success">Active</span>
                                }
                                <span className="d-block small">{userMetaData.payout_remark}</span>

                                {!!isEditPayoutStatus && <>
                                    {userMetaData.payout_status === 2 && <InputFeild className="mt-2" placeholder="Remark" value={isEditPayoutStatus.remark} onChange={(e) => {isEditPayoutStatus.remark = e.target.value; this.setState({ isEditPayoutStatus }) } } />}
                                    <Button className="py-0 mt-2" color="dark" size="sm" onClick={() => this.updatePayoutStatus()}>Save</Button>
                                </>}
                            </Col>

                        </Row>
                    }
                   <Table>
                       <thead>
                           <tr>
                               <th>Payout Title</th>
                               <th>Amount</th>
                               <th>Status</th>
                           </tr>
                       </thead>
                       <tbody>
                           {payoutData.length ?
                            payoutData
                            .slice(this.state.currentPage*10, this.state.currentPage*10 + 10)
                            .map(payout => 
                               <tr>
                                   <td>
                                       <strong className="d-block">{payout.Payout.payout_title}</strong>
                                       <span className="small">{moment(payout.created_on).utcOffset("+05:30").format("Do MMM YY")}</span>
                                    </td>
                                   <td>{payout.amount}</td>
                                   <td>{payout.status_text}</td>
                               </tr>
                           ) :<em className="m-4 text-secondary d-block">No Payout data</em> }
                       </tbody>
                 
                   </Table>                     
                   <TablePagination rowsPerPageOptions={[15]}  count={payoutData.length} rowsPerPage={10}
                    page={this.state.currentPage}
                    onChangePage={ (e, page) => this.setState({currentPage : page}) }
                     component="div"/>
            </div>
           
        );
    }
}
export default UserPayouts;
